import { AbstractControl, ValidationErrors } from '@angular/forms';

const tinRegex = /^[A-Za-z0-9-]{8,15}$/;

export function tinValidator(control: AbstractControl): ValidationErrors | null {
  const { value } = control;

  if (!value || tinRegex.test(value)) {
    return null;
  }

  return { tin: true };
}
